import React from "react";
import PropTypes from 'prop-types';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "./ConfirmCancelDialog";
import { LanguageContext } from './LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniAsiakas;

class AdminRooliProfiiliEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.rooliId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            RooliId: data[0].rooliId,
            AsiakasAvain: data[0].asiakasAvain,
            RooliTunnus: data[0].rooliTunnus,
            RooliNimi: data[0].rooliNimi,
            Globaali: data[0].globaali,
            Created: data[0].created,
            Updated: data[0].updated,
            Username: data[0].username,
            Active: data[0].active,
            asiakkaat: (Object.keys(props.lookupLists.asiakkaat).map(function (d) { return { value: d, label: props.lookupLists.asiakkaat[d] }; }) || []),
            filteredasiakkaat: (Object.keys(props.lookupLists.asiakkaat).map(function (d) { return { value: d, label: props.lookupLists.asiakkaat[d] }; }) || []),
        };

    }

    UNSAFE_componentWillMount() {
        var a = this.state.AsiakasAvain || '';
        iniAsiakas = this.state.asiakkaat.find(({ value }) => value === a.toString());
    }

    static propTypes = {
        onEditRow: PropTypes.func,
        classes: PropTypes.object,
        blurOnSelect: PropTypes.bool
    };

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RooliId: this.state.data[0].rooliId,
            AsiakasAvain: this.state.data[0].asiakasAvain,
            RooliTunnus: this.state.data[0].rooliTunnus,
            RooliNimi: this.state.data[0].rooliNimi,
            Globaali: this.state.data[0].globaali,
            Created: this.state.data[0].created,
            Updated: this.state.data[0].updated,
            Username: this.state.data[0].username,
            Active: this.state.data[0].active
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            RooliId: this.state.RooliId,
            AsiakasAvain: this.state.AsiakasAvain,
            RooliTunnus: this.state.RooliTunnus,
            RooliNimi: this.state.RooliNimi,
            Globaali: this.state.Globaali,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
            Active: this.state.Active
        });

        this.handleClearData();
    }

    render() {
        const { dictionary } = this.context;
        const { lookupLists } = this.props;
        const { asiakkaat } = this.state;

        const handleChange = name => event => {
            this.setState({
                [name]: event.target.value,
                jotainMuuttui: true
            });
        };

        var handleClickOpen = () => {
            this.setState({
                open: true,
                filteredasiakkaat: asiakkaat,
            });
        }

        const handleListChange = (event, newValue, item) => {
            if (newValue != null) {
                this.setState({ [item]: newValue.value })
            }
            else {
                this.setState({ [item]: null })
            }
            this.setState({ jotainMuuttui: true })
        }

        const handleListStateChange = list => {
            const data = (Object.keys(lookupLists[list]).map(function (d) { return { value: d, label: lookupLists[list][d] }; }) || [])
            this.setState({
                [list]: data,
                jotainMuuttui: true
            })
        };

        var handleClose = () => {
            if (this.state.jotainMuuttui) {
                this.setState({
                    setOpen: true
                });
            }
            else {
                this.setState({
                    open: false,
                    setOpen: false
                });
            }
        }

        var handleSetOpenCancel = () => {
            this.setState({
                open: true,
                setOpen: false
            });
        }

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={this.state.open} onClose={handleClose} maxWidth={false} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{dictionary.AdminRooliProfiili.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <input type="hidden" value={this.state.RooliId} />
                        <div style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniAsiakas}
                                onChange={(event, newValue) => { handleListChange(event, newValue, 'AsiakasAvain') }}
                                onInputChange={() => { handleListStateChange('asiakkaat') }}
                                options={asiakkaat}
                                getOptionLabel={(option) => option.label}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.AdminRooliProfiili.Columns[1]} />}
                            />
                        </div>
                        <TextField
                            required={true}
                            margin="dense"
                            id="RooliTunnus"
                            label={dictionary.AdminRooliProfiili.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.RooliTunnus}
                            onChange={handleChange('RooliTunnus')}
                        />
                        <TextField
                            required={true}
                            margin="dense"
                            id="RooliNimi"
                            label={dictionary.AdminRooliProfiili.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.RooliNimi}
                            onChange={handleChange('RooliNimi')}
                        />
                    </DialogContent>
                    {/* TODO:THEME */}
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "AdminRooliProfiiliEdit" })(AdminRooliProfiiliEdit);
